package com.appcreator.dto

import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.properties.ComponentProperty
import kotlin.time.Instant
import kotlinx.serialization.Serializable

@Serializable
data class ComponentResponse(
    val id: String,
    val properties: List<ComponentProperty>,
    val component: Component,
    val updatedAt: Instant
)
